import idb from "@/plugins/indexdb.js";
import SeatRepo from "@/repositories/products/seatRepository";

import seatDefaultForm from "./forms/seat";

export default {
  namespaced: true,

  state: {
    seat: seatDefaultForm
  },

  mutations: {
    SET_SEAT(state, payload) {
      state.seat = Object.assign({}, state.seat, payload);
    },

    // Reset seat object
    RESET_SEAT(state) {
      state.seat = seatDefaultForm;
    }
  },
  actions: {
    /**
     * Get seat product by uuid
     *
     * @param {String} seat_uuid Seat uuid
     */
    async get({ commit }, seat_uuid) {
      try {
        const { data } = await SeatRepo.get(seat_uuid);
        commit("SET_SEAT", data);
        return data;
      } catch (error) {
        throw error;
      }
    },

    // Create a new seat
    async createSeat(context, payload) {
      try {
        const { data } = await SeatRepo.createSeat(payload);
        return data;
      } catch (error) {
        throw error;
      }
    },

    /**
     * Local part
     */

    /**
     * Get seat product from IndexedDB
     *
     * @param {String} seat_uuid Seat uuid
     */
    async getFromLocal({ commit }, seat_uuid) {
      const seat = await idb.db.seat.get(seat_uuid);

      // If not found return null
      if (!seat) return null;

      commit("SET_SEAT", seat);

      return seat;
    },

    // Reset seat
    resetProduct({ commit }) {
      commit("RESET_SEAT");
    }
  }
};
